// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-footer {
  --background: transparent;
  background: transparent;
}

.reg-btn {
  background: var(--ion-color-secondary) !important;
  color: white !important;
  border: none !important;
  border-radius: 0px !important;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  padding: 15px;
  text-transform: uppercase;
}

h1 {
  color: var(--ion-color-main);
  font-family: AppFont-black, sans-serif;
  font-size: 38px;
}

.text-large {
  font-weight: 600;
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/email-confirmation/email-confirmation.page.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,uBAAA;AAFF;;AAIA;EACE,iDAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AADF;;AAGA;EACE,4BAAA;EACA,sCAAA;EACA,eAAA;AAAF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF","sourcesContent":["@use \"../../../theme/mixins\" as *;\n\n\nion-footer {\n  --background: transparent;\n  background: transparent;\n}\n.reg-btn{\n  background: var(--ion-color-secondary) !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 0px !important;\n  width: 100%;\n  font-weight: 700;\n  font-size: 16px;\n  padding: 15px;\n  text-transform: uppercase;\n}\nh1 {\n  color: var(--ion-color-main);\n  font-family: AppFont-black,sans-serif;\n  font-size: 38px;\n}\n.text-large {\n  font-weight: 600;\n  font-size: 22px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
